module.exports = __webpack_public_path__ + "6e26466ab0d88cdb47d10f1c5045c535.png";